import React from 'react';
import {CMSLandingBullets} from '@tempo/landing';
import {Box, Button} from '@tempo/core';
import Link from 'next/link';
import {useResolveTranslations} from '../hooks/useResolveTranslations';

type StrapiBulletsBlockProps = {
	strapiBlockData: any;
	translationNamespace: string;
};

export const StrapiBulletsBlock: React.FC<StrapiBulletsBlockProps> = ({
	strapiBlockData,
	translationNamespace,
}) => {
	const resolve = useResolveTranslations(translationNamespace);
	return (
		<Box bg="background.neutral.secondary.default" py="spacing.3xl" w="100%">
			<Box maxWidth={{base: '100%', md: '1440px'}} mx="auto">
				<CMSLandingBullets
					title={resolve(strapiBlockData.title).replace(/<[^>]+>/g, '')}
					cta={
						<Button as={Link} href={strapiBlockData.cta?.href}>
							{resolve(strapiBlockData.cta?.label)}
						</Button>
					}
					items={strapiBlockData.bulletPoints.map((bp: any) => ({
						text: resolve(bp.bullet).replace(/<[^>]+>/g, ''),
					}))}
				/>
			</Box>
		</Box>
	);
};
